import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';

export interface UiPreferences {
  shippingGuideBannerDismissed: boolean;
  hasSeenTradeConfirmModal: boolean;
  hasSeenFirstTradeCelebration: boolean;
  dismissedBonusTaskKeys?: string[];
}

export const uiPreferencesApi = createApi({
  reducerPath: 'uiPreferencesApi',
  baseQuery: baseQuery,
  tagTypes: ['UiPreferences'],
  endpoints: (builder) => ({
    getUiPreferences: builder.query<UiPreferences, void>({
      query: () => ({
        url: '/settings/ui-preferences',
        method: 'GET',
        requiresAuth: true,
      }),
      providesTags: ['UiPreferences'],
    }),

    updateUiPreferences: builder.mutation<
      { success: boolean; settings: UiPreferences },
      Partial<UiPreferences>
    >({
      query: (body) => ({
        url: '/settings/ui-preferences',
        method: 'PUT',
        body,
        requiresAuth: true,
      }),
      invalidatesTags: ['UiPreferences'],
    }),
  }),
});

export const {
  useGetUiPreferencesQuery,
  useUpdateUiPreferencesMutation,
} = uiPreferencesApi;
